import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react'
import { isNull, isUndefined } from 'lodash'
import type { ReactElement } from 'react'
import { IKReactSelect } from '../../../../../ui-kit'
import type { CMFieldProps } from '.'

const CMBooleanField = ({
  cmField,
  disabled,
  isUpload,
  form,
}: CMFieldProps): ReactElement => (
  <FormControl
    marginBottom={isUpload ? 0 : '30px'}
    isInvalid={Boolean(
      form.errors?.upload &&
        form.touched?.upload &&
        form.errors?.upload[cmField.name] &&
        form.touched?.upload[cmField.name],
    )}
    isRequired={cmField.schema.isValueRequired}
    isDisabled={disabled}
  >
    <FormLabel>{cmField.label}</FormLabel>
    <IKReactSelect
      variant="compact"
      captureMenuScroll={false}
      menuPlacement="auto"
      isClearable
      isDisabled={disabled}
      value={{
        label:
          isUndefined(form?.values?.upload[cmField.name]) ||
          isNull(form?.values?.upload[cmField.name])
            ? undefined
            : String(form?.values?.upload[cmField.name]),
        value:
          isUndefined(form?.values?.upload[cmField.name]) ||
          isNull(form?.values?.upload[cmField.name])
            ? undefined
            : form?.values?.upload[cmField.name],
      }}
      options={[true, false].map(val => ({
        label: String(val),
        value: val,
      }))}
      onChange={newVal => {
        form.setTouched({ ...form.touched, [cmField.name]: true })
        if (isNull(newVal)) {
          form.setFieldValue(`upload.['${cmField.name}']`, null)
        } else {
          form.setFieldValue(`upload.['${cmField.name}']`, Boolean(newVal.value))
        }
      }}
    />
    <FormErrorMessage>
      {form.errors?.upload && form.errors?.upload[cmField.name]}
    </FormErrorMessage>
  </FormControl>
)

export default CMBooleanField
